// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-description_9f005047 {
  line-height: 1.715;
  color: #657682;
  display: none;
  margin-top: 0.334rem;
}
.field-description_shown_9f005047 {
  display: block;
}
.field-description_error_9f005047 {
  color: #b32700;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field-description": `field-description_9f005047`,
	"field-description_shown": `field-description_shown_9f005047`,
	"field-description_error": `field-description_error_9f005047`
};
export default ___CSS_LOADER_EXPORT___;
